/* ============================================================
   KleenKick V3 — GSAP animations
   5 moments: scroll reveals, hero auto-glide, sticky CTA,
              gold glow pulse, FAQ accordion
   ============================================================ */
(function () {
  'use strict';

  if (typeof gsap === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);

  // Init after loader done
  document.addEventListener('kk:loaded', init);
  if (document.body.classList.contains('is-loaded')) init();

  function init() {
    // 1) Scroll-reveal stagger on every section
    document.querySelectorAll('[data-kk-reveal]').forEach((el) => {
      const targets = el.hasAttribute('data-kk-reveal-children')
        ? el.children
        : [el];

      gsap.from(targets, {
        opacity: 0,
        y: 32,
        duration: 0.9,
        ease: 'power3.out',
        stagger: 0.08,
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      });
    });

    // 2) Hero headline — letter reveal stagger
    document.querySelectorAll('[data-kk-headline-reveal]').forEach((el) => {
      const text = el.textContent.trim();
      const words = text.split(' ');
      el.innerHTML = words.map((w) => `<span class="kk-word"><span class="kk-word-inner">${w}</span></span>`).join(' ');

      gsap.from(el.querySelectorAll('.kk-word-inner'), {
        yPercent: 110,
        duration: 1.1,
        ease: 'power4.out',
        stagger: 0.06,
        delay: 0.2
      });
    });

    // 3) Number reveal (01/02/03 for steps)
    document.querySelectorAll('[data-kk-number-reveal]').forEach((el) => {
      gsap.from(el, {
        opacity: 0,
        scale: 0.6,
        rotation: -8,
        duration: 1.2,
        ease: 'expo.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 80%'
        }
      });
    });

    // 4) Magnetic CTA buttons (desktop only)
    if (window.matchMedia('(min-width: 1024px) and (pointer: fine)').matches) {
      document.querySelectorAll('.kk-btn--magnetic, .kk-btn--primary, .kk-btn--featured').forEach((btn) => {
        btn.addEventListener('mousemove', (e) => {
          const rect = btn.getBoundingClientRect();
          const x = e.clientX - rect.left - rect.width / 2;
          const y = e.clientY - rect.top - rect.height / 2;
          gsap.to(btn, { x: x * 0.15, y: y * 0.15, duration: 0.4, ease: 'power2.out' });
        });
        btn.addEventListener('mouseleave', () => {
          gsap.to(btn, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.4)' });
        });
      });
    }

    // 5) Background parallax decorative (subtle)
    document.querySelectorAll('[data-kk-parallax]').forEach((el) => {
      const speed = parseFloat(el.dataset.kkParallax) || 0.3;
      gsap.to(el, {
        yPercent: -20 * speed,
        ease: 'none',
        scrollTrigger: {
          trigger: el.closest('section') || el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    });
  }
})();
